export default __webpack_public_path__ + "images/keyboard-arrow-right.svg";